import { SendLinkConfirmationDialog } from './SendLinkConfirmationDialog';
import { ExternalApplicationFormDialog } from './ExternalApplicationFormDialog';
import { OpenApplicationConfirmationDialog } from './OpenApplicationConfirmationDialog';
import {
    DeliveryMethod,
    ExternalApplicationResponse,
    LoanApplicationSubmitSource2,
    SubmittingUser,
} from '@servicetitan/financing-api-client';
import { ApplicationDataStore } from '../application/ApplicationDataStore';

interface OnCloseHint {
    exitApplication: boolean;
}

interface ExternalApplicationFormProps {
    isSendLinkConfirmationOpen: boolean;
    sendLinkDeliveryMethod?: DeliveryMethod;
    isOpenApplicationConfirmationOpen: boolean;
    onClose: (hint?: OnCloseHint) => void;
    setIsOpen: (isOpen: boolean) => void;
    showTechnicianInstructions: boolean;
    allowSendViaEmail: boolean;
    submittingUser?: SubmittingUser;
    source: LoanApplicationSubmitSource2;
    setIsSendLinkConfirmationOpen: (isOpen: boolean, deliveryMethod?: DeliveryMethod) => void;
    onOpenApplication: (response?: ExternalApplicationResponse) => void;
    skipPlanSelection?: boolean;
}

export const ExternalApplicationForm = ({
    isSendLinkConfirmationOpen,
    sendLinkDeliveryMethod,
    isOpenApplicationConfirmationOpen,
    onClose,
    setIsOpen,
    showTechnicianInstructions,
    allowSendViaEmail,
    submittingUser,
    source,
    setIsSendLinkConfirmationOpen,
    onOpenApplication,
    skipPlanSelection = false,
}: ExternalApplicationFormProps) => {
    const { applicationData } = ApplicationDataStore.useStore();

    return isSendLinkConfirmationOpen ? (
        <SendLinkConfirmationDialog
            deliveryMethod={sendLinkDeliveryMethod!}
            applicantEmail={applicationData.externalApplication.email}
            applicantPhone={applicationData.externalApplication.primaryPhone}
            onReturnToJob={() => onClose({ exitApplication: true })}
            onResendLink={() => setIsSendLinkConfirmationOpen(false)}
        />
    ) : isOpenApplicationConfirmationOpen ? (
        <OpenApplicationConfirmationDialog
            onReturnToProposals={() => onClose({ exitApplication: true })}
        />
    ) : (
        <ExternalApplicationFormDialog
            onSendViaEmail={() => setIsSendLinkConfirmationOpen(true, DeliveryMethod.Email)}
            onSendViaText={() => setIsSendLinkConfirmationOpen(true, DeliveryMethod.Text)}
            onOpenApplication={onOpenApplication}
            onCancel={() => {
                if (skipPlanSelection) {
                    onClose({ exitApplication: true });
                } else {
                    setIsOpen(false);
                }
            }}
            showTechnicianInstructions={showTechnicianInstructions}
            allowSendViaEmail={allowSendViaEmail}
            submittingUser={submittingUser}
            source={source}
        />
    );
};
